import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { consumeZaloPkce } from '../utils/zaloAuth';

// Landing page for Zalo OAuth (/auth/zalo/callback?code=&state=).
// Verifies the state, exchanges the code through our backend, then stores the
// token exactly like the password login does and routes into the app.

const FONT = '"Nunito", "Baloo 2", sans-serif';

export default function ZaloCallbackPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = params.get('code');
    const state = params.get('state') || '';
    if (!code) {
      setError('Zalo không trả về mã đăng nhập (có thể bạn đã hủy).');
      return;
    }
    const verifier = consumeZaloPkce(state);
    if (!verifier) {
      setError('Phiên đăng nhập không hợp lệ hoặc đã hết hạn. Vui lòng thử lại.');
      return;
    }

    const API = process.env.REACT_APP_API_URL;
    (async () => {
      try {
        const r = await fetch(`${API}/login/zalo`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, code_verifier: verifier }),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok || !data.access_token) {
          throw new Error(data.detail || 'Đăng nhập Zalo thất bại');
        }
        localStorage.setItem('accessToken', data.access_token);
        const me = await fetch(`${API}/users/me`, {
          headers: { Authorization: `Bearer ${data.access_token}` },
        }).then(x => (x.ok ? x.json() : null));
        if (me) {
          localStorage.setItem('userFullName', me.full_name || me.email || 'Bạn nhỏ');
          localStorage.setItem('hasCompletedPlacement', me.has_completed_placement ? 'true' : 'false');
          localStorage.setItem('userAvatar', me.avatar || '');
          navigate(me.has_completed_placement ? '/dashboard' : '/onboarding', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (e) {
        setError(String(e.message || e));
      }
    })();
  }, [params, navigate]);

  return (
    <div style={{
      minHeight: '100vh', background: '#FFF8E7', fontFamily: FONT,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{
        maxWidth: 380, width: '100%', textAlign: 'center',
        background: '#fff', border: '1px solid #E8E0CC', borderRadius: 20,
        padding: '36px 26px', boxShadow: '0 4px 16px rgba(139,111,71,0.10)',
      }}>
        {!error ? (
          <>
            <div style={{ fontSize: 46 }}>🦉</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: '#2D2D2D', marginTop: 10 }}>
              Đang đăng nhập với Zalo…
            </div>
            <div style={{ fontSize: 13, color: '#9A9A9A', fontWeight: 600, marginTop: 6 }}>
              Chờ một chút nhé
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 46 }}>😥</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: '#B8431E', marginTop: 10 }}>
              {error}
            </div>
            <button
              onClick={() => navigate('/login', { replace: true })}
              style={{
                marginTop: 18, padding: '12px 26px', border: 'none', borderRadius: 999,
                background: '#E76F51', color: '#fff', fontFamily: FONT,
                fontSize: 14, fontWeight: 800, cursor: 'pointer',
                boxShadow: '0 3px 0 #B8431E',
              }}
            >← Về trang đăng nhập</button>
          </>
        )}
      </div>
    </div>
  );
}
